import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { Button } from '@repo/ui';
import { colorPalette } from '@repo/mui-config/color-palette';

import { useModalStore } from '@/components/modal/modal.store';

interface CancelApplication {
  handleCancelLoan: () => void;
}

export function CancelApplication({ handleCancelLoan }: CancelApplication) {
  const { t } = useTranslation();
  const { additionalProps } = useModalStore();

  const handleFinishCurrentApplication = () => {
    if (typeof additionalProps.handleFinishCurrentApplication === 'function')
      additionalProps.handleFinishCurrentApplication();
  };

  return (
    <Stack
      data-testid="cancel-application"
      alignItems="center"
      sx={{ marginInline: '22px', marginTop: '50px' }}
    >
      <Typography color={colorPalette.ink.main} sx={{ mb: 1 }} textAlign="center" variant="h5">
        {t('dashboard.loanList.cancelModal.title')}
      </Typography>
      <Box
        height="86px"
        sx={{
          marginBottom: '32px',
          marginTop: '0px',
        }}
      >
        <Typography
          color={colorPalette.ink.main}
          lineHeight="16px"
          textAlign="center"
          variant="body1"
          marginBottom={2}
        >
          {t('dashboard.loanList.cancelModal.subtitle')}
        </Typography>
        <Typography
          color={colorPalette.ink.main}
          lineHeight="16px"
          textAlign="center"
          variant="body1"
        >
          {t('dashboard.loanList.cancelModal.question')}
        </Typography>
      </Box>
      <Stack gap="10px" width="100%">
        <Button
          color="info"
          onClick={handleFinishCurrentApplication}
          sx={{
            alignItems: 'center',
            paddingY: '12px',
          }}
          variant="contained"
        >
          {t('dashboard.loanList.cancelModal.continueButton')}
        </Button>
        <Button
          data-testid="button-cancel-application"
          color="primary"
          onClick={handleCancelLoan}
          sx={{ paddingY: '12px', color: colorPalette.ink.main }}
          variant="text"
        >
          {t('dashboard.loanList.cancelModal.cancelButton')}
        </Button>
      </Stack>
    </Stack>
  );
}
